import React from 'react';
import { AppButton, Box, Inscription, Preloader, RoundPendingIcon } from '@common-fe/common-fe';

import ModalWrapper from '@/components/wrappers/ModalWrapper';

interface Props {
  userFullName: string;
  isReactivating: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const ReactivateAuthorizedUserModal: React.FC<Props> = ({ userFullName, isReactivating, onConfirm, onClose }) => (
  <ModalWrapper visible onSetVisible={onClose} testId="authorized-users_reactivate-modal">
    <Box align="center" pad={{ vertical: 'spacing24' }}>
      <RoundPendingIcon color="warning" />
      <Inscription margin={{ top: 'spacing12' }} size="2xl" weight={700} data-testid="authorized-users_reactivate-modal_title">
        Activate {userFullName} as an authorized user?
      </Inscription>
      <Box margin={{ top: 'spacing24' }} direction="row" gap="spacing12">
        <AppButton
          buttonType="secondary"
          width="140px"
          testId="authorized-users_reactivate-modal_cancel"
          onClick={onClose}
        >
          Cancel
        </AppButton>
        <AppButton
          width="140px"
          testId="authorized-users_reactivate-modal_confirm"
          onClick={onConfirm}
        >
          {isReactivating ? (
            <Preloader testId="authorized-users_reactivate-modal_confirm-preloader" color="white" />
          ) : (
            'Activate'
          )}
        </AppButton>
      </Box>
    </Box>
  </ModalWrapper>
);

export default ReactivateAuthorizedUserModal;
